import { Box, Stack, useTheme } from "@mui/material";
import { AllignmentLeftIcon, AttachIcon, Tooltip } from "components";
import { useState } from "react";
import CannedNoteDrawer from "./CannedNoteDrawer";

export const AttachmentButton = ({
  serviceId,
  serviceType,
  serviceSource,
  isDisabled,
  onAttachClick,
  onInsertHtml,
}: {
  serviceId: string;
  serviceType: string;
  serviceSource: string;
  isDisabled: boolean;
  onAttachClick: () => void;
  onInsertHtml?: (html: string) => void;
}) => {
  const theme = useTheme();

  const [isCannedNotesModalOpen, setIsCannedNotesModalOpen] = useState(false);

  return (
    <>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          gap: "8px",
          height: "fit-content",
        }}
      >
        <Tooltip title="Canned Notes">
          <Box>
            <AllignmentLeftIcon
              onClick={() => !isDisabled && setIsCannedNotesModalOpen(true)}
              sx={{ cursor: "pointer" }}
              htmlColor={
                isDisabled
                  ? theme.palette.neutral["020"]
                  : theme.palette.lightBg.low
              }
            />
          </Box>
        </Tooltip>
        <Tooltip title="Attachment">
          <Box>
            <AttachIcon
              onClick={() => !isDisabled && onAttachClick()}
              sx={{ cursor: "pointer" }}
              htmlColor={
                isDisabled
                  ? theme.palette.neutral["020"]
                  : theme.palette.lightBg.low
              }
            />
          </Box>
        </Tooltip>
      </Stack>

      {isCannedNotesModalOpen && (
        <CannedNoteDrawer
          currentServiceId={serviceId}
          open={isCannedNotesModalOpen}
          onClose={() => setIsCannedNotesModalOpen(false)}
          serviceType={serviceType}
          isDisabled={isDisabled}
          originSource={serviceSource || ""}
          onInsertHtml={onInsertHtml}
        />
      )}
    </>
  );
};
